import { render } from "./MostPopularSellers.vue?vue&type=template&id=fd18fa2e&ts=true"
import script from "./MostPopularSellers.vue?vue&type=script&lang=ts"
export * from "./MostPopularSellers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__